import { CountUp } from 'countup.js';

document.addEventListener('DOMContentLoaded', function () {
	let executed = false;
	if (!executed) {
		executed = true;

		let countUpElements = document.querySelectorAll('.countup');
		let observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					let fullText = entry.target.textContent;
					let numericValue = fullText.replace(/[^0-9.]/g, ''); // Extraire seulement la partie numérique
					let value = parseFloat(numericValue);

					// Définir les décimales à afficher seulement si elles sont nécessaires
					let decimalPlaces = (value % 1 !== 0) ? 2 : 0;

					let options = {
						startVal: 0,
						duration: 2.5,
						decimalPlaces: decimalPlaces,  // Utilisation conditionnelle des décimales
						decimal: '.',
						separator: ' ',
						useEasing: true,
						prefix: '',
						suffix: ''
					};

					// Extraire les préfixes et suffixes non numériques
					let prefix = fullText.match(/^(\D*)\d/);
					let suffix = fullText.match(/\d(\D*)$/);
					if (prefix) {
						options.prefix = prefix[1];
					}
					if (suffix) {
						options.suffix = suffix[1];
					}

					let countUp = new CountUp(entry.target, value, options);
					countUp.start();
					observer.unobserve(entry.target);
				}
			});
		});

		countUpElements.forEach(function (element) {
			observer.observe(element);
		});

		// Gestion du menu hamburger
		let hamburger = document.querySelector('.main-menu .hamburger');
		if (hamburger) {
			hamburger.addEventListener('click', function () {
				hamburger.classList.toggle('is-active');
				document.body.classList.toggle('sidenav_is-open');
				document.querySelector(".layout-nav_side").classList.toggle('is-open');
			});
		}
	}
});
